import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {NestApiProvider} from '../../nest-api';
import {ResponseData} from '../../nest-responses';
import {
  RequestCreatePositionDto,
  RequestFindPositionDto,
  RequestUpdatePositionDto,
  ResponseCreatePositionDto,
  ResponseFindPositionDto,
  ResponseUpdatePositionDto
} from '../dto/position.dto';

@Injectable()
export class PositionNestApi {
  private service: string = '';
  private model: string = 'position';

  constructor(
      private nestApiProvider: NestApiProvider
  ) {
  }

  public createPosition(data: RequestCreatePositionDto): Observable<ResponseCreatePositionDto> {
    const method: string = 'POST';
    const func: string = 'createPosition';
    const params: RequestCreatePositionDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseCreatePositionDto>(method, url, params, urlParams, body);
  }

  public updatePosition(data: RequestUpdatePositionDto): Observable<ResponseUpdatePositionDto> {
    const method: string = 'POST';
    const func: string = 'updatePosition';
    const params: RequestUpdatePositionDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseUpdatePositionDto>(method, url, params, urlParams, body);
  }

  public findPosition(paging?: RequestFindPositionDto): Observable<ResponseData<ResponseFindPositionDto[]>> {
    const method: string = 'GET';
    const func: string = 'findPosition';
    const params: any = {};
    const urlParams: any = paging || {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseFindPositionDto[]>>(method, url, params, urlParams, body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/position.api.ts